import { service } from '@ember/service';

import Service from 'ember-cli-flash/services/flash-messages';

const FLASH_MESSAGE_OPTIONS = {
  rawString: true,
  sticky: true,
  componentName: 'api-error',
  showProgress: false,
  destroyOnClick: false,
};

export default class FlashMessagesService extends Service {
  @service intl;

  // Helper to generate flash messages from server errors
  serverError = (error) => {
    if (Array.isArray(error.errors) && error.errors.length) {
      error.errors.forEach((error) => {
        const { message, options } = this._buildServerErrorFlash(error);
        return this.error(message, options);
      });

      return;
    }

    if (error.message) {
      return this.error(error.message, FLASH_MESSAGE_OPTIONS);
    }

    return this.error(error, FLASH_MESSAGE_OPTIONS);
  };

  _buildServerErrorFlash(error) {
    let options = FLASH_MESSAGE_OPTIONS;
    let message = this.intl.t('flash.apiError.default');
    const translationKey = `flash.apiError.${error.title}`;

    if (error.title && this.intl.exists(translationKey)) {
      message = this.intl.t(translationKey);
    }

    let detail = error.detail ?? error.message ?? error.title;

    if (!detail) {
      return { message, options };
    }

    try {
      options = {
        ...FLASH_MESSAGE_OPTIONS,
        data: JSON.parse(detail),
      };
    } catch {
      message = detail;
    }

    return { message, options };
  }

  error() {
    return this.danger(...arguments);
  }
}
